import React from "react";
// import {Row, Col,Card, CardBody, CardHeader} from "reactstrap";
import SummeryPieChart from "./summery-pie-chart";
import { t } from "../multi-language/multi-lang.service";
export var RecordSummeryBox = function (_a) {
    var recordingData = _a.recordingData, reportDates = _a.reportDates;
    var measuring_time = recordingData.measuring_time, measuring_time_percentage = recordingData.measuring_time_percentage, off_wrist_duration = recordingData.off_wrist_duration, off_wrist_duration_percentage = recordingData.off_wrist_duration_percentage, no_measurement_duration = recordingData.no_measurement_duration, no_measurement_duration_percentage = recordingData.no_measurement_duration_percentage, total_time = recordingData.total_time;
    var data = [{ name: 'measuring_time', value: measuring_time_percentage }, { name: 'off_wrist', value: off_wrist_duration_percentage }, { name: 'no_measurement', value: no_measurement_duration_percentage }];
    return (React.createElement("div", { className: "card page-break" },
        React.createElement("div", { className: "bg-transparent card-header" },
            React.createElement("div", { className: "row header-card" },
                React.createElement("div", { className: "col-3 text-start" }, t('charts.recording.summary')),
                React.createElement("div", { className: "col-sm-9 text-end" },
                    t('general_words.from'),
                    " ",
                    reportDates.fromDate,
                    " ",
                    t('general_words.to'),
                    " ",
                    reportDates.toDate))),
        React.createElement("div", { className: "card-body" },
            React.createElement("div", { className: "d-flex justify-content-center" },
                React.createElement("div", { className: "flex-max" },
                    React.createElement(SummeryPieChart, { data: data })),
                React.createElement("div", { className: "flex-max pt-5 ml-n-2" },
                    React.createElement("div", { className: "green-team fs-1 weight-3" }, "".concat(measuring_time_percentage, "% ").concat(t('charts.recording.measure_time'))),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" }, "".concat(off_wrist_duration_percentage, "% ").concat(t('charts.recording.off_wrist'))),
                    React.createElement("div", { className: "light-grey-team fs-1 weight-3 pt-3" }, "".concat(no_measurement_duration_percentage, "% ").concat(t('charts.recording.no_measurement'))),
                    React.createElement("div", { className: "blue-team fs-1 weight-3 pt-3" }, t('charts.recording.total'))),
                React.createElement("div", { className: "flex-max pt-5 ml-3" },
                    React.createElement("div", { className: "grey-team fs-1 weight-3" },
                        measuring_time,
                        " ",
                        t('charts.units.hr')),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" },
                        off_wrist_duration,
                        " ",
                        t('charts.units.hr')),
                    React.createElement("div", { className: "light-grey-team fs-1 weight-3 pt-3" },
                        no_measurement_duration,
                        " ",
                        t('charts.units.hr')),
                    React.createElement("div", { className: "grey-team fs-1 weight-3 pt-3" },
                        total_time,
                        " ",
                        t('charts.units.hr')))))));
};
//# sourceMappingURL=recording-summery-box.js.map